module.exports = __webpack_public_path__ + "img/silom-pos.24b5dafa.png";